import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegulationModel } from 'src/app/core/models/regulation';
import { RuleVersionFilterViewModel, RuleVersionHistory, RuleVersionHistoryModel } from 'src/app/core/models/regulation/version-history-model';
import { SelfAssessment } from 'src/app/core/models/self-assessment/self-assessment';
// import { VersionHistory, VersionHistoryViewModel } from 'src/app/core/models/self-assessment/version-history';
import { VersionHistoryFilter } from 'src/app/core/models/self-assessment/version-history-filter';
import { RegulationService } from 'src/app/core/services/regulation';
import { ChangeDetailComponent } from '../change-detail/change-detail.component';

@Component({
  selector: 'app-rulebook-version-dialog',
  templateUrl: './rulebook-version-dialog.component.html',
  styleUrls: ['./rulebook-version-dialog.component.scss']
})
export class RulebookVersionDialogComponent {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  regulation: RegulationModel;
  versionHistory: RuleVersionHistory[];
  versionHistoryFilter: VersionHistoryFilter;
  takeCount = 0;
  skipCount = 0;
  isLoading = false;
  myInnerHeight: any;
  endIndex = 0;
  totalCount = 0;

  constructor(
    private regulationService: RegulationService, public dialogRef: MatDialogRef<RulebookVersionDialogComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public resultViewData: RuleVersionFilterViewModel) {
    this.myInnerHeight = window.innerHeight - 450;
    this.regulation = resultViewData.regulation;
    this.versionHistory = [];
    this.versionHistoryFilter = new VersionHistoryFilter();
  }

  ngOnInit(): void {
    this.versionHistoryFilter.SortKey = 'Id';
    this.versionHistoryFilter.IsDesc = true;
    this.fetchVersionHistory();
  }

  fetchVersionHistory(): void {
    this.isLoading = true;
    this.versionHistoryFilter.id = this.regulation.id;
    this.versionHistoryFilter.SkipCount = this.skipCount;
    this.versionHistoryFilter.TakeCount = this.takeCount;
    this.regulationService.getVersionHistory(this.versionHistoryFilter).subscribe((result: RuleVersionHistoryModel) => {
      this.versionHistory = result.data;
      this.totalCount = result.totalCount;
      this.isLoading = false;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  sortVersionHistory(key: string): void {
    this.versionHistoryFilter.IsDesc = !this.versionHistoryFilter.IsDesc;
    this.versionHistoryFilter.SortKey = key;
    this.fetchVersionHistory();
  }
  openView(id: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: { id: id, detailType: 2, filterType:"All", isVersion:true, rulebookId:this.versionHistoryFilter.id ,type: 'modal'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      // this.sessionService.isLibraryTabActive = false;
    });
  }
}
